import { TableBody, TableCell, TableRow } from "@mui/material";
import React from "react";
import { tableInputStyle } from "../../../../Utils/CommonStyles/muTableStyle";
import Icons from "../../../../Config/Images";
import Strings from "../../../../Config/Strings";
import Fonts from "../../../../Config/Fonts";
import Colors from "../../../../theme/Colors";

const MenuTableBody = ({
  menuDetails,
  onViewMenuDetails,
  onEditMenuDetails,
  handleShowDeleteModal,
}) => {
  return (
    <tbody>
      {menuDetails?.map((menu, index) => (
        <tr key={index}>
          <td component="th" style={tableDataInputStyle}>
            {index + 1}
          </td>
          <td component="th" scope="row" style={tableDataInputStyle}>
            {menu?.menu_title}
          </td>
          <td align="right" style={tableDataInputStyle}>
            <img
              src={Icons.previewIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
              }}
              onClick={() => onViewMenuDetails(menu)}
              alt="Preview Icon"
            />
            <img
              src={Icons.editIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() => onEditMenuDetails(menu)}
              alt="edit Icon"
            />
            <img
              src={Icons.deleteIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "20px",
              }}
              onClick={() => handleShowDeleteModal(menu?.menu_id)}
              alt="Delete Icon"
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
};

export default MenuTableBody;
